// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2730": "b3bca57d","494": "40775784","6557": "fe427090",}[chunkId] + ".css"
}